const DEFAULT_CONFIG = {
    ignorePaths: {
        regexps: []
    },
    ignoreErrors: {
        strings: [],
        regexps: [
            'Loading chunk',
            'Loading CSS chunk',
            'Network Error',
            'NetworkError'
        ],
        stacktraces: []
    }
};
export { DEFAULT_CONFIG };

//# sourceMappingURL=defaultConfig.mjs.map